var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSettingsIncidents = function SvgSettingsIncidents(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    "aria-hidden": "true",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3967",
    d: "M0 0h50v50H0Z",
    fill: "#f0f0f0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Type 3 small"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11334"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Union 20",
    d: "M22.093 17.541a3 3 0 0 1 5.243 0l6.71 12.058a3 3 0 0 1-2.622 4.459h-13.42a3 3 0 0 1-2.622-4.459Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3967",
    d: "m25.811 24.164-.468 3.982h-.863L24 24.165v-2.164h1.811Zm-.046 4.664V30.5h-1.724v-1.672Z",
    fill: "#f0f0f0"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettingsIncidents, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings-incidents.600e8da5.svg";
export { ForwardRef as ReactComponent };